import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { formatters } from "./utils";

const RelatorioContent = ({ mockData, totais }) => {
  return (
    <Box sx={{ padding: "20px", backgroundColor: "#fff" }}>
      <Typography variant="h6" gutterBottom>
        Resumo das Categorias PIS/COFINS
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#002d72" }}>
            <TableCell sx={cellStyleHead}>Item</TableCell>
            <TableCell sx={cellStyleHead}>Oportunidade</TableCell>
            <TableCell sx={cellStyleHead}>Tese Judicial</TableCell>
            <TableCell sx={cellStyleHead} align="right">
              Valor
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Dados principais */}
          {mockData.length > 0 ? (
            mockData.map((row, index) => {
              const corLinha =
                row.tipo === "SUGESTAO"
                  ? "#dceefb"
                  : row.tipo === "DESNECESSIDADE"
                  ? "#e3e3e3"
                  : "#ffffff";

              return (
                <TableRow key={index} sx={{ backgroundColor: corLinha }}>
                  <TableCell sx={cellStyle} />
                  <TableCell sx={cellStyle}>{row.step}</TableCell>
                  <TableCell sx={cellStyle}>{row.teseJudicial}</TableCell>
                  <TableCell sx={{ ...cellStyle, textAlign: "right" }}>
                    {formatters.monetary(row.valor)}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{ ...cellStyle, textAlign: "center", fontStyle: "italic" }}
              >
                Nenhum resumo encontrado
              </TableCell>
            </TableRow>
          )}

          {/* Linha de separação */}
          <TableRow>
            <TableCell sx={noBorder} />
            <TableCell sx={noBorder} />
            <TableCell sx={totalStyle}>Total</TableCell>
            <TableCell align="right" sx={totalStyle}>
              {formatters.monetary(totais.totalGeral)}
            </TableCell>
          </TableRow>

          {/* Total Desnecessidade */}
          <TableRow>
            <TableCell sx={noBorder} />
            <TableCell sx={noBorder} />
            <TableCell sx={{ ...totalStyle, backgroundColor: "#e3e3e3" }}>
              Desnecessidade de medida judicial
            </TableCell>
            <TableCell
              align="right"
              sx={{ ...totalStyle, backgroundColor: "#e3e3e3" }}
            >
              {formatters.monetary(totais.totalSemJudicial)}
            </TableCell>
          </TableRow>

          {/* Total Sugestão */}
          <TableRow>
            <TableCell sx={noBorder} />
            <TableCell sx={noBorder} />
            <TableCell sx={{ ...totalStyle, backgroundColor: "#dceefb" }}>
              Sugestão de medida judicial
            </TableCell>
            <TableCell
              align="right"
              sx={{ ...totalStyle, backgroundColor: "#dceefb" }}
            >
              {formatters.monetary(totais.totalJudicial)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

// Estilos CSS do INSS aplicados no PIS/COFINS
const cellStyleHead = {
  border: "1px solid #0b0b0b",
  color: "#fff",
  fontWeight: "bold",
};
const cellStyle = { border: "1px solid #0b0b0b" };
const noBorder = { border: "none" };
const totalStyle = { border: "1px solid #0b0b0b", fontWeight: "bold" };

export default RelatorioContent;
